import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";

const WishlistContext = createContext(null);
const STORAGE_KEY = "makerizk_wishlist_v1";

function loadInitial() {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        return saved ? JSON.parse(saved) : [];
    } catch (_) {
        return [];
    }
}

export function WishlistProvider({ children }) {
    const [ids, setIds] = useState(loadInitial);

    useEffect(() => {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
        } catch (_) {}
    }, [ids]);

    const toggle = useCallback((productId) => {
        setIds((prev) =>
            prev.includes(productId) ? prev.filter((i) => i !== productId) : [...prev, productId]
        );
    }, []);

    const has = useCallback((productId) => ids.includes(productId), [ids]);

    const remove = useCallback((productId) => {
        setIds((prev) => prev.filter((i) => i !== productId));
    }, []);

    const clear = useCallback(() => setIds([]), []);

    const value = useMemo(
        () => ({ ids, count: ids.length, toggle, has, remove, clear }),
        [ids, toggle, has, remove, clear]
    );

    return <WishlistContext.Provider value={value}>{children}</WishlistContext.Provider>;
}

export function useWishlist() {
    const ctx = useContext(WishlistContext);
    if (!ctx) throw new Error("useWishlist must be used within WishlistProvider");
    return ctx;
}
